<style scoped>
.project-card {

}
</style>

<template>
    <v-flex xs12 sm3>
        <v-card class="project-card">
            <v-card-title primary-title>
                <div style="text-aligh: left;">
                    <h3 class="headline mb-0">{{ project.name }}</h3>
                    <div style="height: 100px; overflow: none;">{{ project.description }}</div>
                </div>
            </v-card-title>
            <v-card-actions>
                <router-link :to="{name: 'datasources', params: {projectId: project.id}}" target="_blank">
                  <v-btn flat color="orange"> Open </v-btn>
                </router-link>
                <v-btn flat color="orange" v-on:click="goToDatasources(project)"> Manage </v-btn>
            </v-card-actions>
        </v-card>
    </v-flex>
</template>

<script>

import {createNamespacedHelpers} from 'vuex'
const {mapState, mapActions, mapGetters, mapMutations} = createNamespacedHelpers('projects')

export default {
    props: ['project'],
    data: function() {
      return {};
    },
    computed: {
      ...mapState(['dialog']),
      ...mapGetters(['gGet'])
    },
    methods: {
      ...mapMutations(['mAdd', 'mCloseDialog']),
      ...mapActions(['aAdd']),
      goToDatasources: function(project) {
        // console.log('project', project.id);
        this.$router.push({name: 'datasources', params: {projectId: project.id}})
        // this.$router.push({name: 'datasources', params: {projectId: project.id}})
      }
    },
    mounted: function() {

    }
}

</script>
